<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1>Salário Base</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="Salary">Salário</label>
            <input class="form-control form-control-lg" v-focus v-model="salario" type="text" v-mask="'money'" placeholder="R$" required/>
          </div>  
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'

export default {
  data() {
    const pessoal = this.currentUser.Pessoal
    return {
      salario: (pessoal && pessoal.Salario) ? pessoal.Salario.toLocaleString('pr-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      this.currentUser.Pessoal.Salario = Number.parseFloat(Masker.unmaskMoney(this.salario))

      const newData = {Pessoal: this.currentUser.Pessoal}
      this.$emit('on-submit', newData)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/BaseSalaryStep.vue